module.exports = "pegasus_template/assets/themecapture1/tickets/102.png";